'use strict';

/**
 * Prevents the browser back button from navigating away from the current page.
 *
 * Call this in componentDidMount (or a useEffect) and store the returned cleanup
 * function. Call the cleanup in componentWillUnmount (or the useEffect return) to
 * remove the event listener when the component is unmounted.
 *
 * @returns {Function} cleanup function that removes the popstate listener
 */
export function preventBrowserBack() {
  history.pushState(null, null, location.href);

  window.onpopstate = function () {
    history.go(1);
  };
}
